module.exports = __webpack_public_path__ + "resource/img/status_draft.6656b67e.svg";